<script setup>
import { onMounted, inject, watch, ref } from 'vue'
import API from '@/js/api.js'

const emit = defineEmits(['close'])
const props = defineProps(['active'])
const data = ref(null)
const isLoading = ref(true)
const api = inject('api')

const getData = async () => {
  const qs = new URLSearchParams(window.location.search)
  isLoading.value = true

  try {
    data.value = await API.get(
      api.live + '?' + qs + '&location=' + props.active._id + '&is_modal=1'
    )
  } finally {
    isLoading.value = false
  }
}

watch(
  () => props.active,
  async () => {
    data.value = null
    if (props.active) await getData()
  }
)
</script>

<template>
  <div
    class="modal"
    :class="{ 'is-active': props.active }"
    style="z-index: 1001"
  >
    <div class="modal-background" @click="emit('close')"></div>
    <div class="animation-content modal-content map-location-info">
      <header class="is-block">
        <div class="has-text-right">
          <button
            type="button"
            class="button is-black is-small is-square"
            @click="emit('close')"
          >
            <b-icon icon="close"></b-icon>
          </button>
        </div>

        <a
          :href="props.active.link_gmaps"
          target="_blank"
          class="has-text-white is-underlined is-size-7 has-text-weight-bold"
          v-if="props.active?.link_gmaps"
          v-text="props.active?.name"
        />

        <p class="is-size-7 has-text-weight-bold" v-else>
          {{ props.active?.name }}
        </p>

        <p>{{ props.active?.address }}</p>
      </header>

      <main style="min-height: 120px">
        <b-loading :is-full-page="false" v-model="isLoading" />
        <div id="vue-live-grid" v-if="data" v-html="data.html" />
      </main>
    </div>
  </div>
</template>
